import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheIntelligenceGateway from "./sections/TheIntelligenceGateway";
import IndustrySolutions from "./sections/IndustrySolutions";
import TheNeuralEngine from "./sections/TheNeuralEngine";
import TheVisionBehindThePrompts from "./sections/TheVisionBehindThePrompts";
import TheImplementationRoadmap from "./sections/TheImplementationRoadmap";
import PerformanceMetrics from "./sections/PerformanceMetrics";
import InsightsAndInnovation from "./sections/InsightsAndInnovation";
import InitiatePilotProgram from "./sections/InitiatePilotProgram";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheIntelligenceGateway />
      <IndustrySolutions />
      <TheNeuralEngine />
      <TheVisionBehindThePrompts />
      <TheImplementationRoadmap />
      <PerformanceMetrics />
      <InsightsAndInnovation />
      <InitiatePilotProgram />
      <Footer />
    </div>;
}